import React, { Component } from 'react'
import { Field, reduxForm } from 'redux-form'
import { withStyles } from '@material-ui/core/styles'
import cx from 'classnames'

// COMPONENTS
import { ButtonContained, ButtonOutlined } from '../app-button/button'
import renderSelectField from './field/customSelect'
import MenuItem from '@material-ui/core/MenuItem'
import Spinner from '../spinner'
import MultiSelect from './field/multiSelect'

const styles = theme => ({
  chip: {
    width: '100%',
    marginBottom: 16,
  },
  root: {
    paddingLeft: 21,
    paddingRight: 3,
    borderRadius: 4,
    height: 48,
    justifyContent: 'flex-start',
  },
  colorSecondary: {
    fontSize: 16,
    fontWeight: 'normal',
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 1.5,
    letterSpacing: 'normal',
    color: 'rgb(0, 0, 0)',
  },
  deleteIcon: {
    color: '#000',
    marginLeft: 'auto',
    '&:hover': {
      color: '#000',
    },
  },
  label: {
    paddingLeft: 0,
  },
  fieldGroupe: {
    display: 'flex',
  },
  '@keyframes wiggle': {
    '33%': { transform: 'rotateZ(1deg)' },
    to: { transform: 'rotateZ(-1deg)' },
  },

  '@keyframes wiggle2': {
    '33%': { transform: 'rotateZ(1deg)' },
    to: { transform: 'rotateZ(-1deg)' },
  },

  wiggle: {
    willChange: 'transform',
    animationName: 'wiggle',
    animationDuration: '150ms',
    animationIterationCount: 4,
  },
  crmDescriptionSmall: {
    marginTop: 10,
    marginBottom: 5,
    opacity: 0.75,
    fontSize: 12,
  },
  error: {
    padding: '10px 0',
    fontSize: '12px',
    color: '#ff4e44',
  },
  crmRow: {
    display: 'flex',
    alignContent: 'flex-start',
    justifyContent: 'flex-start',
    flexWrap: 'wrap',
  },
  crmColumn: {
    width: 340,
    display: 'flex',
    flexDirection: 'column',
    marginBottom: 15,
    marginRight: 20,
    '&:last-child': {
      marginRight: 0,
    },
  },
})

class EnvyCrmForm3 extends Component {
  state = {
    destination: null,
    pipelines: [],
  }

  handleClick = (classes, submitFailed) => {
    if (submitFailed) {
      this.form.classList.remove(classes.wiggle)

      void this.form.offsetWidth

      this.form.classList.add(classes.wiggle)
    }
  }

  handleChangeDestination = event => {
    this.setState({ destination: event.target.value })

    for (var i in this.state.pipelines) {
      this.props.change('pipelines[' + i + '][cancel_status]', null)
    }
  }

  onChangePipeline = (e, index) => {
    const pipelineId = e.target.value
    const { pipelineStatuses } = this.props

    if (pipelineId == this.state.pipelines[index].id) {
      return false
    }

    let pipelines = [...this.state.pipelines]

    pipelines[index] = {
      id: pipelineId,
      statuses: pipelineStatuses[pipelineId],
    }

    this.setState({ pipelines })

    this.props.change('pipelines[' + index + '][statuses]', null)
    this.props.change('pipelines[' + index + '][cancel_status]', null)
  }

  addNewPipeline = e => {
    e.preventDefault()
    this.setState(state => {
      const pipelines = [
        ...state.pipelines,
        {
          id: null,
        },
      ]
      return {
        pipelines,
      }
    })
  }

  removePipeline = (e, index) => {
    e.preventDefault()

    let pipelines = [...this.state.pipelines]

    pipelines[index] = null

    this.setState({ pipelines })

    this.props.change('pipelines[' + index + ']', null)
  }

  componentDidMount() {
    const { pipelineStatuses } = this.props

    if (
      this.props.initialValues.destination &&
      this.props.initialValues.destination == 'ecom'
    ) {
      this.state.destination = this.props.initialValues.destination
    }

    if (
      this.props.initialValues.pipelines &&
      this.props.initialValues.pipelines.length
    ) {
      const initialPipelines = this.props.initialValues.pipelines
      let pipelines = []

      for (var i in initialPipelines) {
        const initialPipeline = initialPipelines[i]
        const initialPipelineStatuses = pipelineStatuses[initialPipeline.id]

        pipelines.push({
          id: initialPipeline.id,
          statuses: initialPipelineStatuses,
        })
      }

      this.setState({ pipelines })
    } else {
      this.setState({ pipelines: [{ id: null, statuses: [] }] })
    }
  }

  render() {
    const {
      classes,
      handleSubmit,
      submitFailed,
      invalid,
      error,
      isFetching,
    } = this.props

    const menuItemByName = item => {
      return (
        <MenuItem value={item.name} key={item.id}>
          {item.name}
        </MenuItem>
      )
    }

    const menuItemById = item => {
      return (
        <MenuItem value={item.id} key={item.id}>
          {item.name}
        </MenuItem>
      )
    }

    const destinations = () => {
      let list = []

      for (let i in state.destinations) {
        list.push(menuItemById(state.destinations[i]))
      }

      return list
    }

    const availablePipelines = index => {
      let list = []

      const currentPipeline = this.state.pipelines[index]

      for (let i in this.props.availablePipelines) {
        let selectedPipelineIds = []

        if (this.state.pipelines.length) {
          for (var j in this.state.pipelines) {
            if (this.state.pipelines[j] === null) {
              continue
            }

            if (
              currentPipeline !== null &&
              currentPipeline.id === this.state.pipelines[j].id
            ) {
              continue
            }

            selectedPipelineIds.push(this.state.pipelines[j].id)
          }
        }

        if (
          selectedPipelineIds.indexOf(this.props.availablePipelines[i].id) !==
          -1
        ) {
          continue
        }

        list.push(menuItemById(this.props.availablePipelines[i]))
      }

      return list
    }

    const pipelineStatuses = index => {
      const pipeline = this.state.pipelines[index]

      if (!pipeline || !pipeline.id) {
        return []
      }

      let list = []
      const pipelineStatuses = pipeline.statuses

      for (let i in pipelineStatuses) {
        list.push({
          label: pipelineStatuses[i].name,
          value: pipelineStatuses[i].id,
        })
      }

      return list
    }

    const pipelines = () => {
      let list = []

      for (var i in this.state.pipelines) {
        const index = i

        if (this.state.pipelines[index] === null) {
          continue
        }

        list.push(
          <div
            key={index}
            style={{
              marginBottom: 20,
            }}
          >
            <div>
              Настройки воронки
              {index > 0 ? (
                <a
                  href="#"
                  style={{ marginLeft: 10, fontSize: 12 }}
                  onClick={e => this.removePipeline(e, index)}
                >
                  Удалить
                </a>
              ) : null}
            </div>

            <div className={classes.crmRow}>
              <div className={classes.crmColumn}>
                <div className={classes.crmDescriptionSmall}>
                  Выберите воронку из вашей CRM
                </div>
                <div style={{ marginBottom: -16 }}>
                  <Field
                    name={'pipelines[' + index + '][id]'}
                    component={renderSelectField}
                    onChange={e => this.onChangePipeline(e, index)}
                  >
                    <MenuItem value="" style={{ display: 'none' }}>
                      <span style={{ color: 'rgb(0, 0, 0, 0.3)' }}>
                        Выберите воронку
                      </span>
                    </MenuItem>
                    {availablePipelines(index)}
                  </Field>
                </div>
              </div>

              <div className={classes.crmColumn}>
                <div className={classes.crmDescriptionSmall}>
                  Выберите статусы Успешной сделки
                </div>
                <Field
                  name={'pipelines[' + index + '][statuses]'}
                  component={MultiSelect}
                  options={pipelineStatuses(i)}
                  placeholder="Выберите статусы в вашей CRM"
                ></Field>
              </div>
              {this.state.destination == 'ecom' ? (
                <div className={classes.crmColumn}>
                  <div className={classes.crmDescriptionSmall}>
                    Выберите статус Возврата
                  </div>
                  <div style={{ marginBottom: -16 }}>
                    <Field
                      name={'pipelines[' + index + '][cancel_status]'}
                      component={renderSelectField}
                    >
                      <MenuItem value="" style={{ display: 'none' }}>
                        <span style={{ color: 'rgb(0, 0, 0, 0.3)' }}>
                          Выберите статус возврата
                        </span>
                      </MenuItem>
                      {cancelStatuses(index)}
                    </Field>
                  </div>
                </div>
              ) : (
                ''
              )}
            </div>
          </div>
        )
      }

      return list
    }

    const fields = () => {
      let list = []

      for (let i in state.availableFields) {
        list.push(menuItemByName(state.availableFields[i]))
      }

      return list
    }

    const cancelStatuses = index => {
      const pipeline = this.state.pipelines[index]

      if (!pipeline || !pipeline.id) {
        return []
      }

      let list = []

      const pipelineStatuses = pipeline.statuses

      let item = {};
      item.id = "";
      item.name = "";
      list.push(menuItemById(item));
      for (let i in pipelineStatuses) {
        list.push(menuItemById(pipelineStatuses[i]))
      }

      return list
    }

    return (
      <form
        onSubmit={handleSubmit}
        className={cx(
          classes.form,
          { [classes.wiggle]: submitFailed },
          { [classes.novalidate]: invalid }
        )}
        ref={form => (this.form = form)}
      >
        <div className={classes.crmRow}>
          <div className={classes.crmColumn}>
            <div className={classes.crmDescriptionSmall}>
              Выберите, куда хотите отправлять данные
            </div>
            <Field
              name="destination"
              component={renderSelectField}
              onChange={this.handleChangeDestination}
            >
              <MenuItem value="" style={{ display: 'none' }}>
                <span style={{ color: 'rgb(0, 0, 0, 0.3)' }}>
                  Выберите, куда хотите отправлять данные
                </span>
              </MenuItem>
              {destinations()}
            </Field>
          </div>
        </div>

        <div className={classes.crmDescriptionSmall}>
          Выберите поле в вашей CRM, в которое передается Google Client ID. Это нужно для того, чтобы связать данные о продажах из CRM с сессиями в Google Analytics
        </div>
        <Field
          name="field"
          component={renderSelectField}
        >
          <MenuItem value="" style={{ display: 'none' }}>
            <span style={{ color: 'rgb(0, 0, 0, 0.3)' }}>
              Выберите поле CID
            </span>
          </MenuItem>
          {fields()}
        </Field>

        <div className={classes.crmDescriptionSmall}>
          Выберите поле в вашей CRM, в которое передается сумма сделки
        </div>
        <Field
          name="summ_field"
          component={renderSelectField}
        >
          <MenuItem value="" style={{ display: 'none' }}>
            <span style={{ color: 'rgb(0, 0, 0, 0.3)' }}>
              Выберите поле с суммой сделки
            </span>
          </MenuItem>
          {fields()}
        </Field>

        <div>{pipelines()}</div>

        <div>
          <a
            href="#"
            onClick={e => this.addNewPipeline(e)}
            type="button"
            className={classes.alink}
            style={{
              fontSize: 12,
            }}
          >
            Добавить дополнительную воронку
          </a>
        </div>

        {error ? <div className={classes.error}>{error}</div> : ''}
        <ButtonContained
          style={{
            flexShrink: 0,
            fontSize: 16,
            width: '100%',
            height: 48,
            marginTop: 40,
            padding: 0,
            fontWeight: 700,
            color: '#fff',
          }}
          type="submit"
          color="secondary"
          onClick={() => this.handleClick(classes, submitFailed)}
          text={isFetching ? <Spinner /> : 'Завершить'}
        />
      </form>
    )
  }
}

EnvyCrmForm3 = reduxForm({
  form: 'EnvyCrmForm3',
})(EnvyCrmForm3)

export default withStyles(styles)(EnvyCrmForm3)
